// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_OTHER_TOPICS = "Ostatn\u00ed kategorie";
export const FORUM_TOPICS_NOT_FOUND_query = "Nena\u0161ly se \u017e\u00e1dn\u00e9 kategorie se slovem \"%(query)s\".";
export const FORUM_TOPICS_SEARCH_PLACEHOLDER = "Hledej kategorii";
export const LOAD_PREVIOUS = "Na\u010d\u00edst p\u0159edch\u00e1zej\u00edc\u00ed";
